export const COEFFICIENT_MIN = 0.1
export const COEFFICIENT_MAX = 10

export const validateCoefficientRange = (
  value: string | number | undefined | null,
  t: (key: string) => string
) => {
  if (value === '' || value === undefined || value === null) {
    return Promise.resolve()
  }
  const numValue = Number(value)
  if (
    Number.isNaN(numValue) ||
    numValue < COEFFICIENT_MIN ||
    numValue > COEFFICIENT_MAX
  ) {
    return Promise.reject(
      new Error(
        `${t('coefficient_value_range')}: ${COEFFICIENT_MIN.toFixed(
          2
        )} - ${COEFFICIENT_MAX.toFixed(2)}`
      )
    )
  }
  return Promise.resolve()
}
